var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6026 7.79659H11.7432V5.41514C11.8864 3.1411 10.1674 1.17152 7.89346 1.01036C5.61942 0.849243 3.63193 2.58609 3.48869 4.86007C3.47083 5.03918 3.47083 5.21815 3.48869 5.39727C3.48869 5.70165 3.7215 5.93447 4.02589 5.93447C4.33027 5.93447 4.56309 5.70166 4.56309 5.39727C4.43769 3.71411 5.69117 2.24592 7.37433 2.10264C9.05749 1.97724 10.5257 3.23072 10.669 4.91388C10.6868 5.075 10.6868 5.21826 10.669 5.3794V7.76084H2.61144C1.71616 7.76084 1 8.477 1 9.37228V15.3886C1 16.2838 1.71616 17 2.61144 17H12.6028C13.498 17 14.2142 16.2838 14.2142 15.3886V9.40809C14.2142 8.51281 13.4979 7.79665 12.6026 7.79665L12.6026 7.79659ZM13.1398 15.4244C13.1398 15.7288 12.907 15.9616 12.6026 15.9616H2.61128C2.3069 15.9616 2.07408 15.7288 2.07408 15.4244V9.40809C2.07408 9.10371 2.30689 8.87089 2.61128 8.87089H12.6026C12.907 8.87089 13.1398 9.1037 13.1398 9.40809V15.4244Z",
    fill: "#FA4B4B",
    stroke: "#FA4B4B",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.607 10.0347C6.64016 10.0347 5.87016 10.8225 5.888 11.7894C5.888 12.5235 6.37148 13.186 7.0698 13.4188V14.7976H8.1442V13.4188C9.05735 13.1144 9.54084 12.1296 9.23644 11.2165C9.00363 10.518 8.34116 10.0347 7.607 10.0347ZM7.607 12.416C7.24892 12.416 6.94453 12.1116 6.94453 11.7535C6.94453 11.3955 7.2489 11.0911 7.607 11.0911C7.9651 11.0911 8.26948 11.3954 8.26948 11.7535C8.26948 12.1116 7.9651 12.416 7.607 12.416Z",
    fill: "#FA4B4B",
    stroke: "#FA4B4B",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.dce9ee06d97ce417728f3a129cf5ea04.svg";
export { ForwardRef as ReactComponent };